// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Page-with-Sidebar_wrapper__qsSE0 {
  margin: 15px 0;
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 15px;
}

.Page-with-Sidebar_wrapper__qsSE0>div {
  background: white;
}

.Page-with-Sidebar_content__WmuJs {
  padding: 30px;
}

.Page-with-Sidebar_content__WmuJs h2 {
  margin-top: 0;
}

.Page-with-Sidebar_notifications__vxava>div {
  display: grid;
  gap: 10px;
  grid-template-columns: 100px 1fr;
}

.Page-with-Sidebar_notifications__vxava>div p {
  margin-top: 0;
  font-size: 0.8rem;
}

.Page-with-Sidebar_notifications__vxava>div span {
  font-weight: bold;
  font-size: 1.1rem;
  align-self: center;
  justify-self: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/Page-with-Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB","sourcesContent":[".wrapper {\n  margin: 15px 0;\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 15px;\n}\n\n.wrapper>div {\n  background: white;\n}\n\n.content {\n  padding: 30px;\n}\n\n.content h2 {\n  margin-top: 0;\n}\n\n.notifications>div {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: 100px 1fr;\n}\n\n.notifications>div p {\n  margin-top: 0;\n  font-size: 0.8rem;\n}\n\n.notifications>div span {\n  font-weight: bold;\n  font-size: 1.1rem;\n  align-self: center;\n  justify-self: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Page-with-Sidebar_wrapper__qsSE0`,
	"content": `Page-with-Sidebar_content__WmuJs`,
	"notifications": `Page-with-Sidebar_notifications__vxava`
};
export default ___CSS_LOADER_EXPORT___;
